import TokenResource from "./TokenResource";

export default class PopRegResource extends TokenResource {
	streetAddress = "";
	postalCode = "";
	city = "";

	pk() {
		return this.postalCode;
	}

	static url = () => {
		return PopRegResource.urlRoot;
	};

	static urlRoot = "/api/popreg";
}
